import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { getLineGraphData } from '../calculations/utilsV2';
import { getColorByGroup } from '../calculations/calcV2';

interface LineGraphProps {
  title: string,
  countryStat: CountryStat,
};

export const LineGraphV2 = (props: LineGraphProps) => {
    const { countryStat, title } = props;
    const { labels, groups, parties, dataItems } = getLineGraphData(countryStat);

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );
    
const options: any = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      datalabels: {
        display: false,
      },
      title: {
        display: true,
        text: title,
      },
    },
  };
  
    const lineData = {
        labels,
        datasets: dataItems.map((x, i) => ({
                label: parties[i],
                data: x,
                backgroundColor: getColorByGroup(groups[i]),
                borderColor: getColorByGroup(groups[i]),
            })),
      };

    return <Line options={options} data={lineData} />;
}